 



// THIS CODE IS GENERATED.  CHANGES MADE TO THIS FILE WILL BE LOST.

import { Injectable } from '@angular/core';

import { ClientBase } from '../shared/core/ovs.core';
import { ResortSummary } from '../models/presentation.model';

export abstract class ResortSummaryClientBase extends ClientBase
{
	public abstract Get(nameid: string, checkin: string, latitude: number, longitude: number, country: number, state: number, searchId: string,  success?: (value: Array<ResortSummary>) => void, error?: (error: any) => void): void;
}

@Injectable()
export class ResortSummaryClient extends ResortSummaryClientBase
{
	public Get(nameid: string, checkin: string, latitude: number, longitude: number, country: number, state: number, searchId: string, success?: (value: Array<ResortSummary>) => void, error?: (error: any) => void): void
	{
        let params: any = {};
		params.checkin = checkin;
		params.latitude = latitude;
		params.longitude = longitude;
		params.country = country;
		params.state = state;
		params.searchId = searchId;
		params.breakIt = 0;
		params.nameid = nameid;
        this.baseGetArray<ResortSummary>("api/ResortSummary", ResortSummary, params, success, error);
	}
}







// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/resort-summary.client.ts